import React, { useEffect, useState } from 'react'
import st from './SettingUser.module.scss'
import {
  EditIconButton,
  HeaderAddButton,
} from 'components/UI/SuperButton/SuperButton'
import { localisationMaster } from 'Localisation/Localisation'
import asideModalStore from 'Stores/asideModalStore'
import styles from 'components/ContentBox/Global/ReportTable/Table.module.scss'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import AddNewUser from 'components/ContentBox/Global/GlobalModalSingle/templates/CRM/AddNewUser/AddNewUser'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import useLocalization from 'hooks/useLocalization'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import { superAxiosRequest } from 'axiosApi'
import cogoToast from 'cogo-toast'
import { observer } from 'mobx-react'
import Loader from 'components/ContentBox/Global/Loader/Loader'
import { useHistory } from 'react-router-dom'
import { ReactComponent as DeleteIcon } from 'components/UI/icons/delete-bin-6-line.svg'
import swal from 'sweetalert'
import Pagination from 'components/UI/Pagination/Pagination'

const initPagination = {
  page: 1,
  limit: 10,
}

const SettingsUser = () => {
  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore
  const [filter, updateFilter] = useLocalStorageFilter()
  const history = useHistory()
  const [pagination, setPagination] = useState(initPagination)
  const [employees, setEmployees] = useState([])
  const [roles, setRoles] = useState([])
  const [selectedUserId, setSelectedUserId] = useState(null)
  const [loading, setLoading] = useState(false)

  const { translate } = useLocalization({
    section: 'ebooks',
    subsection: 'ebooks_books',
    dict: {
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      save: 'Save',
      filter: 'Filter',
      company: 'Company',
      reset_all: 'Reset all',
      apply: 'Apply',
      search: 'Search',

      employee: 'Employee',
      search_placeholder: 'Search...',
      add_employee: 'Add a Employee',
      name: 'Name',
      internal_number: 'Internal number',
      branch: 'Branch',
      extension_number: 'Extension number',
      role: 'Role',
      all_roles: 'All roles',
      all_branches: 'All branches',
      page: 'Page',
      of: 'of',
      role_not_found: 'Role not found',

      edit_employee: 'Edit Employee',
      first_name: 'First Name',
      last_name: 'Last Name',
      contacts: 'Contacts',
      short_number: 'Short number',
      update: 'Update',
      user_card: 'User card',
      delete_confirm: 'Are you sure you want to delete',
    },
  })

  const handleCheckboxChange = (userId) => {
    setSelectedUserId((prevSelectedUserId) =>
      prevSelectedUserId === userId ? null : userId,
    )
  }

  const addNewUser = () => {
    const ms = {
      modalBodyComponent: () => <AddNewUser addNewUser />,
      button: translate.save,
      link: 'integration/employees',
      title: translate.user_card,
      crm: true,
      onSubmitSuccess: (data) => fetchEmployees(),
      isResponsive: true,
      valid: {
        first_name: 'required',
        last_name: 'required',
        email: 'required_email',
        mobile_phone: 'required_phone',
        branch: 'required',
        role_id: 'required',
      },
    }
    const md = {}
    asideModalStore.activity(ms, md)
  }

  const editUser = () => {
    const userToEdit = employees.result.find(
      (employee) => employee.id === selectedUserId,
    )
    if (!userToEdit) {
      cogoToast.error('Выберите пользователя для редактирования.')
      return
    }

    const ms = {
      modalBodyComponent: () => <AddNewUser userData={userToEdit} />,
      isResponsive: true,
      crm: true,
      title: translate.edit_employee,
      button: translate.update,
      is_put: true,
      link: `integration/employees/${userToEdit.id}`,
      onSubmitSuccess: () => fetchEmployees(),
    }
    asideModalStore.activity(ms, {
      first_name: userToEdit.first_name,
      last_name: userToEdit.last_name,
      mobile_phone: userToEdit.mobile_phone,
      email: userToEdit.email,
      branch: userToEdit.branch.id,
      role_id: userToEdit.role_id,
      phoenix_id: userToEdit.phoenix_id,
      wazzup_channel: userToEdit.channel_id,
    })
  }

  const deleteEmployee = () => {
    const userToEdit = employees.result.find(
      (employee) => employee.id === selectedUserId,
    )
    if (!userToEdit) {
      cogoToast.error('Выберите пользователя для редактирования.')
      return
    }
    swal({
      title: localisationMaster('text_2', 'alert'),
      text: `${translate.delete_confirm} ${userToEdit.first_name} ${userToEdit.last_name} ?`,
      icon: 'warning',
      buttons: [
        localisationMaster('button_2', 'alert'),
        localisationMaster('button_1', 'alert'),
      ],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const apiConf = {
          method: 'delete',
          crm: true,
          link: `integration/employees/${userToEdit.id}`,
        }
        superAxiosRequest(apiConf).then(() => {
          const updatedEmployees = employees.result.filter(
            (employee) => employee.id !== userToEdit.id,
          )
          setEmployees({ ...employees, result: updatedEmployees })
        })
      } else {
        swal(localisationMaster('text_5', 'alert'))
      }
    })
  }

  //filter
  const filterCfg = [
    {
      type: 'select',
      apiLink: 'accounts/crm_roles',
      nameState: 'role_id',
      label: translate.all_roles,
      placeholder: translate.all_roles,
    },
    {
      type: 'select',
      apiLinkCRM: 'integration/branches',
      nameState: 'branch_id',
      label: translate.all_branches,
      placeholder: translate.all_branches,
    },
  ]

  const fetchEmployees = () => {
    superAxiosRequest({
      link: `integration/employees`,
      method: 'get',
      crm: true, // Новый домен
      params: {
        offset: (pagination.page - 1) * pagination.limit,
        limit: pagination.limit,
        ...filter,
      },
    })
      .then((response) => {
        setEmployees(response.data)
      })
      .catch((error) => {
        console.error('Error fetching employees:', error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    setLoading(true)

    fetchEmployees()

    superAxiosRequest({
      link: `accounts/crm_roles`,
      method: 'get',
    })
      .then((response) => {
        setRoles(response.data)
      })
      .catch(() => {})
  }, [filter, pagination])

  useEffect(() => {
    return AsideFilterStore.unmountFilter
  }, [])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== '/crm/settings-user') {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  const getRoleNameById = (roleId) => {
    const role = roles.find((role) => role.id === roleId)
    return role ? role.name : translate.role_not_found
  }

  return (
    <div className={st.container}>
      <div className={st.settingUserBox}>
        <div className={st.settingUserBox__head}>
          <PageHeader title={translate.employee}>
            <div className={st.settingUserBox__headBtn}>
              <span className={st.settingUserBox__delete}>
                <DeleteIcon onClick={deleteEmployee} />
              </span>
              <div className={st.settingUserBox__headBtn__divider}></div>
              <EditIconButton onClick={() => editUser()} />
              <div className={st.settingUserBox__headBtn__divider}></div>
              <HeaderAddButton
                title={translate.add_employee}
                onClick={() => addNewUser()}
              />
            </div>
          </PageHeader>

          <div className={st.searchFilterValues}>
            <SearchBooks
              onSearch={(text) => {
                updateFilter({ ...filter, search: text })
                changeTextValue('search', {
                  key: 'search',
                  label: translate.search,
                  value: text,
                })
              }}
              onClear={() => {
                const { search, ...obj } = filter
                updateFilter(obj)
                setTextValues(
                  filterTextValues.filter((field) => field.key !== 'search'),
                )
              }}
              translate={translate}
              placeholder={translate.search_placeholder}
              value={filter?.search || ''}
            />

            {!!filterTextValues.length && (
              <FilterTextValues
                onDelete={(key) => {
                  const { [key]: _, ...obj } = filter
                  updateFilter(obj)
                }}
              />
            )}

            {isOpenFilter && (
              <AsideFilter
                translate={translate}
                getFilterParams={(e) => updateFilter(e)}
                config={filterCfg}
                filterValue={filter}
                onDropFilter={() => {
                  updateFilter({})
                  closeFilter()
                }}
              />
            )}
          </div>
        </div>
      </div>

      {loading ? (
        <Loader />
      ) : employees.result && employees.result.length > 0 ? (
        <>
          <div className={st.settingUserBox}>
            <table className={`${styles.table} ${styles.tbodyStriped}`}>
              <thead className={`${styles.conversionTbl} ${st.thead}`}>
                <tr>
                  <td className={`${st.tdTotal} ${styles.tdMiddle} `}>
                    {translate.name}
                  </td>
                  <td className={`${st.tdTotal} ${styles.tdMiddle} `}>
                    {translate.internal_number}
                  </td>
                  <td className={`${st.tdTotal} ${styles.tdMiddle} `}>
                    Канал WA
                  </td>
                  <td className={`${st.tdTotal} ${styles.tdMiddle} `}>
                    {translate.branch}
                  </td>
                  <td className={`${st.tdTotal} ${styles.tdMiddle} `}>
                    E-mail
                  </td>
                  <td className={`${st.tdTotal} ${styles.tdMiddle} `}>
                    {translate.extension_number}
                  </td>
                  <td className={`${st.tdTotal} ${styles.tdMiddle} `}>
                    {translate.role}
                  </td>
                </tr>
              </thead>
              <tbody className={styles.conversionTbl}>
                {employees.result.map((employee, index) => (
                  <tr key={index}>
                    <td className={`${styles.tdTotal} ${styles.tdMiddle}`}>
                      <div className={st.table__checkbox}>
                        <input
                          type='checkbox'
                          onChange={() => handleCheckboxChange(employee.id)}
                          checked={selectedUserId === employee.id}
                        />
                        <span>{employee.full_name}</span>
                      </div>
                    </td>
                    <td
                      className={`${styles.tdTotal} ${styles.bdrN} ${styles.tdMiddle} ${styles.bdlN}`}
                    >
                      {employee?.mobile_phone}
                    </td>
                    <td
                      className={`${styles.tdTotal} ${styles.bdrN} ${styles.tdMiddle} ${styles.bdlN}`}
                    >
                      {employee?.wazzup_channel?.name || '-'}
                    </td>
                    <td
                      className={`${styles.tdTotal} ${styles.bdrN} ${styles.tdMiddle} ${styles.bdlN}`}
                    >
                      {employee.branch && employee.branch.name}
                    </td>
                    <td
                      className={`${styles.tdTotal} ${styles.bdrN} ${styles.tdMiddle} ${styles.bdlN}`}
                    >
                      {employee.email}
                    </td>
                    <td
                      className={`${styles.tdTotal} ${styles.bdrN} ${styles.tdMiddle} ${styles.bdlN}`}
                    >
                      {employee?.sipuni_short_number}
                    </td>
                    <td
                      className={`${styles.tdTotal} ${styles.bdrN} ${styles.tdMiddle} ${styles.bdlN}`}
                    >
                      {getRoleNameById(employee.role_id)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {employees?._meta?.count_items > 10 && (
            <Pagination
              translate={translate}
              limit={pagination.limit}
              count={employees._meta?.count_items || 0}
              page={pagination.page}
              onChange={(page) => setPagination({ ...pagination, page })}
              onChangePerPage={(limit) => {
                setPagination({ page: 1, limit })
              }}
            />
          )}
        </>
      ) : (
        <h1 className={st.noData}>Нет данных для отображения!</h1>
      )}
    </div>
  )
}

export default observer(SettingsUser)
